<h1 class="text-center mt-2">Plan N’Go - Gestion des concessions</h1>
<div class="user-table m-3">
  <div class="mt-5 mx-4 d-flex justify-content-between align-items-start">
    <div class="d-flex">
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Groupe</mat-label>
        <mat-select [(ngModel)]="selectedGroup" (click)="focusSearch('section')" (selectionChange)="filterDealership()"  appearance="fill" [compareWith]="comparer">
          <mat-option value="all">Tous</mat-option>
          <input id="select-search-section" class="form-control select-input custom-search-input" (keyup)="filterGroup($event)" type="text" placeholder="Recherche">
          <mat-option *ngFor="let group of groupsArray.filtered"  [value]="group.groupe_id">
            {{group.nom}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="selectedType" (selectionChange)="filterDealership()"  appearance="fill" [compareWith]="comparer">
          <mat-option value="all">Tous</mat-option>
          <mat-option *ngFor="let type of typesArray"  [value]="type.id">
            {{type.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Combine</mat-label>
        <mat-select [(ngModel)]="combineDealership" (selectionChange)="filterDealership()"  appearance="fill" multiple>
          <mat-option value="master">Oui (mères)</mat-option>
          <mat-option value="child">Oui (enfants)</mat-option>
          <mat-option value="not">Non</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Actif</mat-label>
        <mat-select [(ngModel)]="activeDealership" (selectionChange)="filterDealership()"  appearance="fill" multiple>
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Cherchez une concession</mat-label>
      <input [(ngModel)]="search" matInput (keyup)="applyFilter($event)">
    </mat-form-field>
  </div>
</div>

<div class="example-container">
  <table mat-table [dataSource]="dataSource" class="user-table mat-elevation-z8" >

    <ng-container matColumnDef="concession_id">
      <th mat-header-cell *matHeaderCellDef style="width: 50px" class="pointer" (click)="sortId()"> ID </th>
      <td mat-cell *matCellDef="let element"> {{element.concession_id}} </td>
    </ng-container>

    <ng-container matColumnDef="nom_concession">
      <th mat-header-cell *matHeaderCellDef class="pointer" (click)="sortName()"> Nom </th>
      <td mat-cell *matCellDef="let element"> {{element.nom_concession}} </td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Marques </th>
      <td mat-cell *matCellDef="let element"> <mat-icon class="pointer" (click)="onClickBrand(element.concession_id)">tag</mat-icon> </td>
    </ng-container>

    <ng-container matColumnDef="configuration">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Configuration soft-net </th>
      <td mat-cell *matCellDef="let element"> <mat-icon class="pointer" (click)="onClickConfiguration(element.concession_id)">settings</mat-icon> </td>
    </ng-container>

    <ng-container matColumnDef="informations">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Informations </th>
      <td mat-cell *matCellDef="let element"> <mat-icon class="pointer" (click)="onClickInformations(element.concession_id)">info</mat-icon> </td>
    </ng-container>

    <ng-container matColumnDef="operation">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Opérations </th>
      <td mat-cell *matCellDef="let element"> <mat-icon class="pointer" (click)="onClickOperation(element.concession_id)">build</mat-icon> </td>
    </ng-container>

    <ng-container matColumnDef="mobilite">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Mobilités </th>
      <td mat-cell *matCellDef="let element"> <mat-icon class="pointer" (click)="onClickMobilite(element.concession_id)">directions_car</mat-icon> </td>
    </ng-container>

    <ng-container matColumnDef="synchro">
      <th mat-header-cell *matHeaderCellDef style="width: 50px"> Synchronisation </th>
      <td mat-cell *matCellDef="let element"><div class="pointer" style="width: fit-content" (click)="onClickSynchro(element.concession_id)" ><i class="fa-solid fa-arrows-rotate"></i></div></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="getPageSizeOptions()"
                 (click)="displayPaginatorAllOption()"
                 (page)="pageChange()"
                 showFirstLastButtons
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>

<div class="loader-maintenance" *ngIf="isSyncLoading">
  <div class="loader-dialog">
    <h4 class="m-3 text-center">{{titleLoader}}</h4>
    <div class="loader-container">
      <app-spinner></app-spinner>
    </div>
    <button class="btn btn-outline-dark m-3" (click)="isSyncLoading = false">Charger en arriere-plan</button>
  </div>
</div>
